import { useLanguage } from "../i18n/LanguageContext";
import { CONTACT } from "../i18n/translations";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] text-white py-14 md:py-20"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16">
          <div className="md:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_lopez-designs/artifacts/3dduntlq_architectorial_logo_transparent.png"
              alt="Architectorial studio logo"
              className="h-32 md:h-40 w-auto object-contain mb-6 -ml-2"
            />
            <div className="font-serif text-[1.75rem] md:text-3xl font-light mb-1 leading-tight">
              Oriol López
            </div>
            <div className="text-[12px] sm:text-xs uppercase tracking-[0.28em] text-white/55 mb-6">
              {t.footer.role}
            </div>
            <p className="text-[1.05rem] sm:text-sm text-white/70 max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] sm:text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">
              Contact
            </div>
            <ul className="space-y-2 text-[1rem] sm:text-sm">
              <li>
                <a
                  href={CONTACT.emailHref}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.phoneHref}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  {CONTACT.phone}
                </a>
              </li>
              <li className="text-white/60">{t.contact.info.location}</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] sm:text-[10px] uppercase tracking-[0.28em] text-white/40 mb-4">
              Navigate
            </div>
            <ul className="space-y-2 text-[1rem] sm:text-sm">
              {["home", "services", "about", "contact"].map((id) => (
                <li key={id}>
                  <button
                    onClick={() =>
                      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="text-white/80 hover:text-white transition-colors capitalize"
                  >
                    {t.nav[id]}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <div className="text-xs text-white/40">
            © {year} Oriol López. {t.footer.rights}
          </div>
          <div className="text-xs text-white/40">{CONTACT.email}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
